import React from 'react';
import { useHVAConversation } from './HVAProductAndOrdersContext';
import { Card, Badge } from 'react-bootstrap';

const OrdersList = () => {
  const { orders, clientInfo } = useHVAConversation();

  // Filtrar pedidos por cliente si hay un cliente seleccionado
  const clientOrders = clientInfo
    ? orders.filter(order => order.cliente.id === clientInfo.customerId)
    : [];

  const getStatusColor = (status: string) => {
    switch (status.toLowerCase()) {
      case 'entregado':
        return 'success';
      case 'enviado':
      case 'en tránsito':
        return 'primary';
      case 'en preparación':
        return 'warning';
      default:
        return 'secondary';
    }
  };

  if (clientOrders.length === 0) {
    return (
      <div className="mt-3">
        <h5 className="mb-2">Pedidos del Cliente</h5>
        <Card className="border shadow-sm">
          <Card.Body className="p-3 fs-9 text-center text-muted">
            No hay pedidos disponibles para este cliente
          </Card.Body>
        </Card>
      </div>
    );
  }

  return (
    <div className="mt-3">
      <h5 className="mb-2">Client orders</h5>
      <p className="fs-9 lh-sm mb-2">
        Select a customer to view their orders. In this proof of concept, only
        one order has been included for each customer. Each order is in a
        different status to test the agent's various responses.
      </p>
      <div className="d-flex flex-column gap-3">
        {clientOrders.map(order => (
          <Card key={order.id} className="border shadow-sm">
            <Card.Body className="p-3 pt-3 pb-2">
              <div className="d-flex justify-content-between align-items-start mb-1">
                <h6 className="mb-0">Pedido: {order.id}</h6>
                <Badge bg={getStatusColor(order.estado)}>{order.estado}</Badge>
              </div>
              <p className="mb-1 fs-10">
                Fecha: {new Date(order.fecha_pedido).toLocaleDateString()}
              </p>
              <div className="border-top pt-1">
                <p className="mb-1 fs-9 fw-bold">Productos:</p>
                {order.productos.map(prod => (
                  <div
                    key={prod.id}
                    className="fs-9 d-flex justify-content-between"
                  >
                    <span>{prod.id}</span>
                    <span>
                      {prod.cantidad} x {prod.precio_unitario}€
                    </span>
                  </div>
                ))}
              </div>
              <div className="border-top mt-1 pt-1">
                <div className="d-flex justify-content-between">
                  <span className="fs-9 fw-bold">Total:</span>
                  <span className="fs-8 fw-bold">
                    {order.total.toFixed(2)}€
                  </span>
                </div>
              </div>
              <div className="border-top mt-2 pt-2 fs-9">
                <p className="mb-0">
                  <strong>Envío:</strong> {order.envio.metodo}
                </p>
                <p className="mb-0">
                  <strong>Estado:</strong> {order.envio.estado_envio}
                </p>
                {order.envio.numero_seguimiento && (
                  <p className="mb-1">
                    <strong>Seguimiento:</strong>{' '}
                    {order.envio.numero_seguimiento}
                  </p>
                )}
              </div>
            </Card.Body>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default OrdersList;
